<script>
  import SectionHeader from '../components/SectionHeader.svelte';
  import { fade } from 'svelte/transition';
  import { Progress } from 'sveltestrap';
  import { form } from '../validate.js';
  import { UpdaterService } from '../services/updater-service.js';
  import { getUBMaxRecords, getUBMaxRecordsByDatabases } from '../services/ubmax-sync-service';
  import { toast, stickyToast,  clearToasts} from '../components/Toast.svelte';
  import { ServiceState } from '../constants.js';
  import { user } from '../store.js';

  let ubmaxUser = {};

  const updaterService = UpdaterService();

  $: syncProgress = $updaterService.status === ServiceState.IDLE ?
    0 :
    ($updaterService.record / $updaterService.records) * 100;

  const { validate, ...syncForm } = form(() => ({
    username: { value: ubmaxUser.username, validators: ["required"]},
    password: { value: ubmaxUser.password, validators: ["required"]}
  }));

  const sync = async () => {
    try {
      clearToasts();
      let updates = [];
      if ($user.databases && $user.databases.length) {
        updates = await getUBMaxRecordsByDatabases($user.databases);
      } else {
        updates = await getUBMaxRecords(ubmaxUser.username, ubmaxUser.password);
      }
      await updaterService.sync(updates);
      toast('success', 5000, 'Success', 'Sync with UBMax was successfully completed.');
    } catch (err) {
      stickyToast('danger', 'Error', `An error occured while syncing with UBMax. Please verify username/password. If this
        error persists please contact customer support`);
    }
  }
</script>

<div in:fade="{{duration: 1000}}">
  <SectionHeader section='Residents' subsection='Sync'>
  </SectionHeader>
  <div class='row'>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="alert alert-primary no-border-radius" role="alert">
            <h4 class="alert-heading">Sync Residents with UBMax</h4>
            <p>This process will add new residents that exist in UBMax but not in Public Alert, update existing residents in Public Alert with values from UBMax and remove residents from Public Alert that are no longer active in UBMax.</p>
    
          </div>
          <form class="forms-sample">
            <div class='row'>
              {#if !$user.databases}
                <div class="form-group col-md-6">
                  <label for="input-username" class='required-field'>UBMax Username</label>
                  <input 
                    type="text" 
                    class="form-control"
                    class:border-danger={!$syncForm.username.valid && $syncForm.username.dirty}
                    bind:value={ubmaxUser.username} 
                    use:validate={ubmaxUser.username}
                    id="input-username" 
                    placeholder="Username">
                    {#if $syncForm.username.errors.includes('required') && $syncForm.username.dirty}
                      <p class='text-danger text-small'>Username name is required</p>
                    {/if}
                </div>
                <div class="form-group col-md-6">
                  <label for="input-password" class='required-field'>UBMax Password</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    class:border-danger={!$syncForm.password.valid && $syncForm.password.dirty}
                    bind:value={ubmaxUser.password} 
                    id="input-password" 
                    placeholder="Password">
                    {#if $syncForm.password.errors.includes('required') && $syncForm.password.dirty}
                      <p class='text-danger text-small'>Password is required</p>
                    {/if}
                </div>
              {/if}
            </div>
            <button 
              type="submit" 
              class="btn btn-primary mr-2"
              class:disabled={!$syncForm.valid && !$user.databases}  
              on:click|preventDefault={sync}>
                Start Sync
              </button>
          </form>
        </div>

      </div>
    </div>
  </div>
  <div>
    <strong>Status:</strong> {$updaterService.status}
  </div>
  <div class='row'>
    <div class='col-md-12'>
      {#if $updaterService.status != ServiceState.IDLE}
        <div class='text-center'>{$updaterService.record} of {$updaterService.records}</div>
      {/if}
      <Progress animated value={syncProgress} style="height: 20px;">{syncProgress}%</Progress>
    </div>
  </div>
</div>

<style>
  .required-field::after {
    content: "*";
    color: red;
  }

  .no-border-radius {
    border-radius: 0px;
  }
</style>